import { makeStyles } from '@material-ui/core';
import { MexIcon } from './MexIcon';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  icon: {
    width: 'auto',
    height: 40,
    flexShrink: 0,
  },
  name: {
    color: '#FFFFFF',
    fontFamily: 'Montserrat, Arial, sans-serif',
    fontWeight: 600,
    fontSize: 15,
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
  },
});

/** Seal of the Government of Mexico and the name on two lines: the sidebar is narrow. */
export const LogoFull = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <MexIcon className={classes.icon} />
      <div className={classes.name}>
        Cámara de
        <br />
        Compensación
      </div>
    </div>
  );
};
